import React, { useMemo } from 'react'
import type { TableRowSelection } from 'antd/es/table/interface'
import { InvoiceDeliveryItemDto } from '../../api/dto/invoice-delivery.dto'
import { hasInvoiceFile } from './utils'

/**
 * Any row with a file is selectable; send eligibility is checked in the hook
 * and reported by the bulk bar. The header checkbox selects every listed row
 * on every page, so a whole month can be sent at once.
 */
export const useDeliveryRowSelection = (
  deliveries: InvoiceDeliveryItemDto[],
  selectedRowKeys: React.Key[],
  onSelectedRowKeysChange: (keys: React.Key[]) => void
): TableRowSelection<InvoiceDeliveryItemDto> =>
  useMemo(
    () => ({
      selectedRowKeys,
      // The header click is handled by onSelectAll, which states the intent.
      onChange: (keys, _rows, info) => {
        if (info.type !== 'all') onSelectedRowKeysChange(keys)
      },
      onSelectAll: (selected) =>
        onSelectedRowKeysChange(
          selected ? deliveries.filter(hasInvoiceFile).map((d) => d.id) : []
        ),
      getCheckboxProps: (record) => ({ disabled: !hasInvoiceFile(record) }),
    }),
    [deliveries, selectedRowKeys, onSelectedRowKeysChange]
  )
